import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as M from "materialize-css/dist/js/materialize";

@Injectable()
export class GlobalService {

    constructor(private router: Router) { }
    
    rootUrl = '';
	public credentials = { username: '', password: '' };
	//credentialsChanged: Observable<any>
	authenticated = false;
	//authenticatedChanged: Observable<any>
	authenticatedObserver: any;
	credentialsObserver: any;
	user = '';
	idUstanove = '';
    idFakulteta = '';
	nazivUstanove = '';
	domeni = [];
    odabraniDomen: any = {};
    isLogged = false;
    jeSa = false;

    loginRoute = 'loginPage';
    
    public logout(){
        localStorage.setItem('acmetoken', '');
    }

	loadUser(data:any){
        //console.log(data);
        this.setAuthenticated(true);
        this.user = data.username;
        this.credentials.username = data.username;
        this.jeSa = false; 
        this.idFakulteta = data.idFakulteta;
        
        if (data.jeSa && data.jeSa == 1){
            this.jeSa = true; 
        }
	}
	
	setAuthenticated(authenticated:any) {
        this.authenticated = authenticated;
    }
    setCredentials(credentials:any) {
        this.credentials = credentials;
    }
    setUser(user:any){
        this.credentials.username = user;
        //this.credentialsObserver.next(this.credentials);
    }
    getCredentials(){
        return this.credentials;
    }
        
    cleardata(){
        this.setAuthenticated(false);
        this.credentials = {username : '', password : ''};
        //this.globalSrvc.odjeljenjeClass='active';
        this.user='';
	}   
	
	CheckInt(inputVal){
        let intPatern = /^\d+$/;
        if (!(intPatern.test(inputVal))){
            return false;
        }
        let intVal = parseInt(inputVal, 10);
        if (!Number.isInteger(intVal)){
            return false;
        }
        return true;
    }
    CheckJmbg(inputVal){
        let intPatern = /^\d+$/;
        if (!(intPatern.test(inputVal))){
            return false;
        }
        if (inputVal.length != 13){
            return false;
        }
        return true;
    }
    CheckNumber(inputVal){
        let floatPatern = /^\d+(\.\d+)?$/;
        if (!(floatPatern.test(inputVal))){
            return false;
        }
        let floatVal = parseFloat(inputVal);
        if (isNaN(floatVal)){
            return false;
        }
        return true;
    }

    redirectToHome(){
        if (this.jeSa)
        this.router.navigate(["adminHomePage"]);
        else
            this.router.navigate(["homePage"]);
    }
    redirectToLogin(){
        this.cleardata();
        this.router.navigate(["loginPage"]);
        //this.router.navigate(["register"]);
    }

    initControls(){
        document.addEventListener('DOMContentLoaded', function () {
            var elems = document.querySelectorAll('.datepicker');
            var instances = M.Datepicker.init(elems, { 
                firstDay: true, 
                format: 'dd.mm.yyyy',
                i18n: {
                    months: ["Januar", "Februar", "Mart", "April", "Maj", "Jun", "Jul", "Avgust", "Septembar", "Oktobar", "Novembar", "Decembar"],
                    monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Avg", "Sep", "Okt", "Nov", "Dec"],
                    weekdays: ["Nedjelja","Ponedjeljak", "Utorak", "Srijeda", "Četvrtak", "Petak", "Subota"],
                    weekdaysShort: ["Ned","Pon", "Uto", "Sri", "Čet", "Pet", "Sub"],
                    weekdaysAbbrev: ["N","P", "U", "S", "Č", "P", "S"]
                }
            });

            elems = document.querySelectorAll('select');
            instances = M.FormSelect.init(elems, {});
        });
    }

    openBlob(data, outType){
        var file; 
        if (outType == 'word'){
            file = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'});
        }
        else
        {
            if (outType == 'pdf')
                file = new Blob([data], {type: 'application/pdf'});
            else 
                file = new Blob([data], {type: 'application/vnd.ms-excel'});    
        }
        var fileURL = URL.createObjectURL(file);
        //console.log(fileURL);
        window.open(fileURL);
    }
}
